import { render, staticRenderFns } from "./FrequencyButton.vue?vue&type=template&id=6c897ca7&scoped=true&"
import script from "./FrequencyButton.vue?vue&type=script&lang=js&"
export * from "./FrequencyButton.vue?vue&type=script&lang=js&"
import style0 from "./FrequencyButton.vue?vue&type=style&index=0&id=6c897ca7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c897ca7",
  null
  
)

export default component.exports